<template>
  <div class="header-wrap">
    <div class="header-left">
      <van-image :src="config.logo" @click="router.push('/mobile/chat')">
        <template v-slot:loading>
          <van-loading/>
        </template>
      </van-image>
      {{ config.title }}
    </div>
    <div class="header-right">
      <div v-if="route.path !== '/login' && isLogin" class="display-flex">
        <van-button v-if="enabled_alipay" class="vip mr-10" round @click="router.push('/mobile/member')">
          <van-icon name="bag" size="12" class="mr-5"/>
          套餐
        </van-button>
        <img :src="session.avatar" width="26" height="26" alt="" @click="router.push('/mobile/user')"/>
      </div>
      <div class="login" v-else @click="login">登录/注册</div>
    </div>
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import {useSessionStore} from "@/store/session";
import {onMounted, ref} from "vue";
import {getConfigSystem} from "@/api/config";
import {showDangerNotify} from "@/utils/notification";

onMounted(() => {
  getConfig();
});
const props = defineProps({
  isLogin: Boolean
});
const session = useSessionStore();
const route = useRoute();
const router = useRouter();
const enabled_alipay = ref(true);
const login = () => {
  if (route.path === "/login") return;
  router.push("/login");
};

const config = ref({});
const getConfig = async () => {
  try {
    const res = await getConfigSystem();
    if (res.code === 0) {
      // 更新配置数据
      config.value = res.data;
      enabled_alipay.value = !!res.data.enabled_alipay; // 确保布尔值
    }
  } catch (error) {
    // 错误处理
    showDangerNotify(`获取配置失败：${error.message || "网络错误"}`);
  }
};

</script>

<style lang="stylus">
.header-wrap {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3000;
  height: 36px;
  box-sizing: border-box
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100vw);
  padding: 5px 16px;
  box-shadow: 0px 4px 10px 0px rgba(163, 168, 180, 0.25);
  font-size: 12px;
  background: #fff;

  .header-left {
    display: flex;
    align-items: center;
    font-weight: 700;

    img {
      width: 26px;
      height: 26px;
      margin-right: 10px;
    }
  }

  .header-right {
    display: flex;
    align-items: center;

    img {
      border-radius: 5px;
    }

    .login {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border-radius: 20px;
      color: #5E5AE6;
      background-color: #D6E0FF;
      text-align: center;
    }

    .vip {
      background: #EBF8ED
      color: #43BE58;
      height: 26px;
      padding: 0 8px;
      border: none;
      font-size: 12px;
    }

    .mr-10 {
      margin-right: 10px;
    }
  }
}

.vant-popover {
  width: 90px;
  background: #fff;
  z-index: 1000;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(50, 50, 51, 0.12);

  .van-popover__action {
    width: 100%;
  }
}
</style>
